<script>
    import MobileWrapper from './MobileWrapper.svelte';
</script>

<MobileWrapper>
    <slot />
</MobileWrapper>
